"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SQBuilder = exports.FilterDataType = exports.SearchByFieldMatcher = void 0;
const tslib_1 = require("tslib");
const Base64 = tslib_1.__importStar(require("base-64"));
const utf8 = tslib_1.__importStar(require("utf8"));
var SearchByFieldMatcher;
(function (SearchByFieldMatcher) {
    SearchByFieldMatcher["STARTS_WITH"] = "startsWith";
    SearchByFieldMatcher["ENDS_WITH"] = "endsWith";
    SearchByFieldMatcher["EXACT_MATCH"] = "exactMatch";
    SearchByFieldMatcher["INCLUDES"] = "includes";
    SearchByFieldMatcher["EXISTS"] = "exists";
    /**
     * Can be used to make direct comparisons, also e.g. search in arrays:  {tags: ["tag", "nacht"]} --> fieldname: "tag", matcher: "equals", value: "tag"
     */
    SearchByFieldMatcher["EQUALS"] = "equals";
    /**
     * Can be used to match against an array of values: {tag: "hello"} --> fieldname: "tag", matcher: "in", value: ["tag", "nacht"]
     */
    SearchByFieldMatcher["IN"] = "in";
    SearchByFieldMatcher["GREATER_THAN"] = "greaterThan";
    SearchByFieldMatcher["GREATER_THAN_EQUALS"] = "greaterThanEquals";
    SearchByFieldMatcher["LESS_THAN"] = "lessThan";
    SearchByFieldMatcher["LESS_THAN_EQUALS"] = "lessThanEquals";
    /**
     * Can be used to compare relative dates. The given property must be lessThanEquals to Date.now() + VALUE
     */
    SearchByFieldMatcher["BEFORE_RELATIVE_TIME"] = "beforeRelativeTime";
    /**
     * Can be used to compare relative dates. The given property must be greaterThanEquals to Date.now() + VALUE
     */
    SearchByFieldMatcher["AFTER_RELATIVE_TIME"] = "afterRelativeTime";
    /** Can be used to select entities by a property that is a date and in the given relative month (0 is current month, -1 is last month, +1 is next month) */
    SearchByFieldMatcher["IN_RELATIVE_MONTH"] = "inRelativeMonth";
})(SearchByFieldMatcher = exports.SearchByFieldMatcher || (exports.SearchByFieldMatcher = {}));
var FilterDataType;
(function (FilterDataType) {
    FilterDataType["STRING"] = "string";
    FilterDataType["NUMBER"] = "number";
    FilterDataType["BOOLEAN"] = "boolean";
    FilterDataType["DATE"] = "date";
    FilterDataType["ID"] = "id";
    FilterDataType["FOREIGN_ID"] = "foreignId";
})(FilterDataType = exports.FilterDataType || (exports.FilterDataType = {}));
/**
 * Search Query Builder
 */
class SQBuilder {
    static asSearchQuery(fields, logicalOperator = "or") {
        return {
            fieldSearches: fields,
            logicalOperator
        };
    }
    static asString(fields, logicalOperator = "or") {
        return SQBuilder.toBase64String(SQBuilder.asSearchQuery(fields, logicalOperator));
    }
    static toBase64String(searchQuery) {
        return Base64.encode(utf8.encode(JSON.stringify(searchQuery)));
    }
    static fromBase64String(searchQueryString) {
        return JSON.parse(utf8.decode(Base64.decode(searchQueryString)));
    }
}
exports.SQBuilder = SQBuilder;
